import React, { useEffect } from "react";
import "../styles/home.css";
import "../styles/hotels.css";
import "../styles/school.css";
import "../styles/default.css";
import Footer from "./common/Footer.jsx";
import Navbar from "./common/Navbar.jsx";

const Privacy = () => {
  useEffect(() => {
    // Scroll event listener
    const handleScroll = () => {
      const elements = document.querySelectorAll(".toshow");

      elements.forEach((element) => {
        const windowHeight = window.innerHeight;
        const elementTop = element.getBoundingClientRect().top;
        const showPoint = 5;

        if (elementTop < windowHeight - showPoint) {
          element.classList.add("toshowactive");
        } else {
          element.classList.remove("toshowactive");
        }
      });
    };

    // Attach the scroll event listener
    window.addEventListener("scroll", handleScroll);

    // Cleanup the event listener on component unmount
    return () => {
      window.removeEventListener("scroll", handleScroll);
    };
  }, []);

  return (
    <>
      <Navbar />
      <div className="homeMainContainer">
        <h1>Privacy Policy</h1>
        <p>Last Updated: 2025</p>

        <h2>1. Introduction</h2>
        <p>
          At IBloTec, we are committed to protecting your privacy. This Privacy
          Policy explains how we collect, use, and safeguard your personal
          information when you use our platform for e-commerce, educational
          services, car rentals, and house rentals.
        </p>

        <h2>2. Information We Collect</h2>
        <p>We collect the following types of information:</p>
        <ul>
          <li>
            <strong>Personal Information:</strong> Name, email address, phone
            number, payment details, and identification documents (for rentals).
          </li>
          <li>
            <strong>Usage Data:</strong> IP address, browser type, device
            information, and pages visited.
          </li>
          <li>
            <strong>Transaction Data:</strong> Purchase history, rental
            bookings, and payment records.
          </li>
        </ul>

        <h2>3. How We Use Your Information</h2>
        <p>We use your information to:</p>
        <ul>
          <li>Provide and improve our services.</li>
          <li>Process transactions and bookings.</li>
          <li>Communicate with you about your account and services.</li>
          <li>Send promotional offers and updates (with your consent).</li>
          <li>Ensure the security of our platform.</li>
        </ul>

        <h2>4. Sharing Your Information</h2>
        <p>We may share your information with:</p>
        <ul>
          <li>
            <strong>Service Providers:</strong> Payment processors, delivery
            services, and IT support.
          </li>
          <li>
            <strong>Partners:</strong> Sellers, educators, car rental agencies,
            and property hosts.
          </li>
          <li>
            <strong>Legal Authorities:</strong> When required by law or to
            protect our rights.
          </li>
        </ul>

        <h2>5. Data Security</h2>
        <p>
          We use industry-standard security measures to protect your data,
          including encryption and secure servers. However, no method of
          transmission over the internet is 100% secure.
        </p>

        <h2>6. Your Rights</h2>
        <p>You have the right to:</p>
        <ul>
          <li>Access, update, or delete your personal information.</li>
          <li>Opt out of marketing communications.</li>
          <li>Withdraw consent for data processing.</li>
        </ul>
        <p>
          To exercise these rights, contact us at
          <a href="mailto:support@iblotec.com">support@iblotec.com</a>.
        </p>

        <h2>7. Cookies and Tracking</h2>
        <p>
          We use cookies and similar technologies to enhance your experience.
          You can disable cookies in your browser settings, but this may affect
          platform functionality.
        </p>

        <h2>8. Third-Party Links</h2>
        <p>
          Our platform may contain links to third-party websites. We are not
          responsible for their privacy practices.
        </p>

        <h2>9. Changes to This Policy</h2>
        <p>
          We may update this Privacy Policy from time to time. You will be
          notified of any changes, and continued use of the platform constitutes
          acceptance of the updated policy.
        </p>

        <h2>10. Contact Us</h2>
        <p>
          If you have any questions about this Privacy Policy, please contact us
          at
          <a href="mailto:support@iblotec.com">support@iblotec.com</a>.
        </p>
      </div>
      <Footer />
    </>
  );
};

export default Privacy;
